import React, {useEffect,useState} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Dialog from "@material-ui/core/Dialog";
import {DialogTitle} from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button"; 
import OtherIncomePayment from "./otherIncomePayment";
import {MaterialTable} from '../../../components';
import Icon from '@material-ui/core/Icon';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(2, 0)
    }
}));

let currentPayment = undefined
let editPaymentMode = false
const OtherIncomePaymentDetails = ({onPaymentEdit, data ,banks,   handlePaymentDetailsClose, showPaymentDetailsDialog, onOtherIncomePaymentSave,
     onOtherIncomePaymentDelete, loading}) => {
    const classes = useStyles();
    const [showPaymentDialog, setShowPaymentDialog] = useState(false)
    const [otherIncomePayments, setOtherIncomePayments] = useState([])

     const reset = () => {
        console.debug(data)
        if(showPaymentDetailsDialog && data !== undefined && data.otherIncomePayments !== undefined && data.otherIncomePayments !== null){
            console.debug(data)
            setOtherIncomePayments(data.otherIncomePayments);
        }else{
            setOtherIncomePayments([])
        }
    };
    useEffect(reset, [showPaymentDetailsDialog,data]);


    function onNewPayment(event) {
        editPaymentMode = false;
        event.preventDefault();
        setShowPaymentDialog(true);
    } 

    function onEdit(rowData) {
        rowData = {
            ...rowData,
            bankIndex:banks.findIndex((bank)=>{return bank.id === rowData.paymentBankId;})
        };
        currentPayment = rowData
        editPaymentMode = true
        setShowPaymentDialog(true);
    }

    function onPaymentDelete(rowData) {
        console.debug(rowData,otherIncomePayments)
        let index = otherIncomePayments.findIndex((srcOtherIncomePayment) => {
            return srcOtherIncomePayment.id === rowData.id;
        });
        let newOtherIncomePayments = otherIncomePayments;
        newOtherIncomePayments.splice(index, 1); 
        console.debug(newOtherIncomePayments)
        setOtherIncomePayments(newOtherIncomePayments)
        let tempCurrentData = {
            ...data,
            otherIncomePayments :newOtherIncomePayments
        }
        onOtherIncomePaymentDelete(rowData, tempCurrentData)
        console.debug(otherIncomePayments)
    }


    function onPaymentSave(payment) {
        console.debug(payment,data)
        console.debug(otherIncomePayments)
        if(editPaymentMode){
            let index = otherIncomePayments.findIndex((srcPayement) => {
                return srcPayement.id === payment.id;
            });
            setOtherIncomePayments([...otherIncomePayments.slice(0, index),
                {...payment},
                ...otherIncomePayments.slice(index + 1)])
    
            let tempCurrentData ={
                ...data,
                otherIncomePayments :[...otherIncomePayments.slice(0, index),
                    {...payment},
                    ...otherIncomePayments.slice(index + 1)]
            }

            onPaymentEdit(payment, tempCurrentData)
        }else{
            payment = {
                ...payment,
                otherIncomeId : data.id
            }
            onOtherIncomePaymentSave(payment)
        }
        setShowPaymentDialog(false);
        console.debug(otherIncomePayments)
    }


    function handlePaymentClose() {
        currentPayment = undefined;
        setShowPaymentDialog(false);
    }

    let actions = [
        rowData => ({
            icon: () => <Icon color='primary'>edit</Icon>,
            tooltip: 'Edit otherIncome Details',
            onClick: (event, rowData) => onEdit(rowData),
            hidden:rowData.paymentNote === "Bulk Payment" ? true : false
        }),
        rowData => ({
            icon: () => <Icon color='error'>delete</Icon>,
            tooltip: 'Delete otherIncome Details',
            onClick: (event, rowData) => onPaymentDelete(rowData),
            hidden:rowData.paymentNote === "Bulk Payment" ? true : false
        })
    ]
    return <Dialog maxWidth='md' open={showPaymentDetailsDialog} onClose={handlePaymentDetailsClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog- title"   >OtherIncome Payments</DialogTitle>
          <DialogContent>
            <div className={classes.button} >
                <Button variant="contained" color="primary" onClick={onNewPayment}>Add Payment</Button>
            </div>

            <MaterialTable
            isLoading={loading}
            columns={[
                {title: 'id', field: 'id', hidden: true},
                {title: 'Payment Date', field: 'paymentDate',  editable: 'never',
                render: rowData => {
                    return <span>{moment(rowData.paymentDate).format("DD-MM-YYYY")}</span>
                }
                },
                {title: 'Payment Amount', field: 'paymentAmount',  editable: 'never'},
                {title: 'Payment Mode', field: 'paymentMode', editable: 'never',
                render: rowData => {
                    return <span>{rowData.paymentMode === 0 ? '' : (rowData.paymentMode === 1 ? 'Cash' : rowData.paymentBankName.String)}</span>
                }
                },
                {title: 'paymentBankId', field: 'paymentBankId', editable: 'never', hidden: true},
                {title: 'Payment Note', field: 'paymentNote', editable: 'never'},
            ]}
            data={otherIncomePayments}
            options={{
                actionsColumnIndex: -1,
                search: false,
                showTitle: false,
                
                toolbar: false,
                paging:false
            }} 
            //style={{boxShadow: 'unset'}}
            actions={actions}
            /> 

 {showPaymentDialog ? 

                 <OtherIncomePayment banks={banks} data={currentPayment} onSave={onPaymentSave} handlePaymentClose={handlePaymentClose} 
                showPaymentDialog={showPaymentDialog} editMode={editPaymentMode} >
                </OtherIncomePayment>  

                : null
            }
            <DialogActions>
                <Button
                    className={classes.button}
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={handlePaymentDetailsClose}
                >
                    Close
                </Button>
            </DialogActions>
        </DialogContent>
    </Dialog>
};

export default OtherIncomePaymentDetails;